/**
 * Envío PJ-1 · utilidades puras del panel Personajes (con test propio).
 */

export const listToText = (list) => (list || []).join(', ');
export const textToList = (text) => String(text || '').split(',').map((s) => s.trim()).filter(Boolean);
export const linesToList = (text) => String(text || '').split('\n').map((s) => s.trim()).filter(Boolean);

const same = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
const isEmpty = (v) => v == null || v === ''
  || (Array.isArray(v) && v.length === 0)
  || (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0);

/**
 * Sólo lo que cambió de la ficha. Una clave que quedó vacía viaja como null
 * (el servidor la borra); las que no cambiaron no viajan.
 */
export const fieldsPatch = (original, draft) => {
  const out = {};
  const keys = new Set([...Object.keys(original || {}), ...Object.keys(draft || {})]);
  keys.forEach((k) => {
    const before = (original || {})[k];
    const after = (draft || {})[k];
    if (same(before, after)) return;
    if (isEmpty(after)) {
      if (!isEmpty(before)) out[k] = null;
      return;
    }
    out[k] = after;
  });
  return out;
};

/** La voz principal del personaje con un cambio aplicado (crea una si no hay). */
export const withVoice = (voices, patch) => {
  const list = [...(voices || [])];
  const first = list[0] || { role: 'principal', provider: 'elevenlabs', languageCode: 'es' };
  list[0] = { ...first, ...patch };
  return list;
};
